import React, { useRef, useEffect } from 'react';
import { castAs } from 'Src/types/cast-helpers';
type Props = {
  pspData: any;
};
export const FormAutoSubmit = ({ pspData }: Props) => {
  const formRef = useRef<HTMLFormElement>(null);
  useEffect(() => {
    formRef.current?.submit();
  }, []);
  return (
    <form
      ref={formRef}
      id={pspData.id}
      className="ContactInfoRedirectForm"
      data-testid="PaymentProcess-FormAutoSubmit"
      method={pspData.method}
      action={pspData.url}
    >
      {Object.entries(pspData.fields).map(([fieldName, fieldValue]) => {
        return (
          <input
            key={fieldName}
            type="hidden"
            name={fieldName}
            value={castAs<string | number | readonly string[]>(fieldValue)}
          />
        );
      })}
    </form>
  );
};
